/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-10 17:40:12
 * @LastEditTime: 2019-08-12 19:51:15
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views'

Vue.use(Router)

// 处理不滚动到顶部的逻辑
// function handleNoScroll (to, from) {
//   let rule = /introduction/
//   if (rule.test(to.name) && rule.test(from.name)) {
//     return true
//   }
//   if (/magicCourse/.test(to.name) && /magicCourse/.test(from.name)) {
//     return true
//   }
//   return false
// }

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    console.log(to, from, savedPosition)
    // if (savedPosition) {
    //   return savedPosition
    // } else {
    const position = {}
    if (to.hash) {
      position.selector = to.hash
      console.log(position, 'router 12211')
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position
      }

      return false
    }
    // }
    // if (handleNoScroll(to, from)) {
    //   return false
    // }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: Home,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'index',
          component: () => import(/* webpackChunkName: "index" */ '@/views/home/index.vue')
        },
        {
          path: 'download',
          name: 'downloadCenter',
          component: () => import(/* webpackChunkName: "downloadCenter" */ '@/views/downloadCenter')
        },
        {
          path: 'about_us',
          redirect: '/about_us',
          component: () => import(/* webpackChunkName: "abouts_us_wrapper" */ '@/views/aboutUs/wrapper.vue'),
          children: [
            {
              path: '',
              name: 'aboutUs',
              component: () => import(/* webpackChunkName: "abouts_us_wrapper" */ '@/views/aboutUs/index.vue')
            },
            {
              path: 'news_center',
              redirect: '/about_us/news_center/list',
              component: () => import(/* webpackChunkName: "NewCenter" */ '@/views/newsCenter'),
              children: [
                {
                  path: 'list',
                  name: 'newsList',
                  component: () => import(/* webpackChunkName: "NewsList" */ '@/views/newsCenter/list')
                },
                {
                  path: 'detail',
                  name: 'newsDetail',
                  component: () => import(/* webpackChunkName: "NewDetail" */ '@/views/newsCenter/detail')
                }
              ]
            }
          ]
        },
        {
          path: 'production',
          redirect: '/production/shuangshi',
          component: () => import(/* webpackChunkName: "production" */ '@/views/production/index.vue'),
          children: [
            {
              path: 'shuangshi',
              name: 'shuangshi',
              component: () => import(/* webpackChunkName: "shuangshi" */ '@/views/production/shuangshi.vue')
            },
            {
              path: 'ssLive',
              name: 'ssLive',
              component: () => import(/* webpackChunkName: "ssLive" */ '@/views/production/ssLive.vue')
            },
            {
              path: 'ai',
              name: 'ai',
              component: () => import(/* webpackChunkName: "ai" */ '@/views/production/ai.vue')
            },
            {
              path: 'content',
              name: 'content',
              component: () => import(/* webpackChunkName: "content" */ '@/views/production/content.vue')
            }
          ]
        },
        {
          path: 'success-info',
          name: 'successInfo',
          component: () => import(/* webpackChunkName: "successInfo" */ '@/views/successInfo/index.vue')
        }
      ]
    },
    {
      path: '*',
      name: 'notfound',
      component: () => import(/* webpackChunkName: "notFound" */ '@/views/notFound'),
      redirect: '/'
    }
  ]
})
